import React from 'react';

function GearSelectionPanel({ availableGear, selectedGear, onGearSelect, onGearUnequip, onClose, teamPlayers = [], isOpponentView = false, isMobile = false, equippedCount = 0 }) {
    // Set consistent width for both panels
    // Available Gear is the same width as Current Equipment
    const panelWidth = isMobile ? '40vw' : '300px';
    return (
        <div style={{
            width: panelWidth,
            maxWidth: panelWidth,
            backgroundColor: '#f8f9fa',
            border: '2px solid #ddd',
            borderRadius: '8px',
            padding: isMobile ? '10px' : '15px',
            minHeight: isMobile ? '250px' : '352px',
            maxHeight: isMobile ? '300px' : '450px',
            boxSizing: 'border-box'
        }}>
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                marginBottom: '5px',
                borderBottom: '2px solid #ecf0f1',
                paddingBottom: '2px'
            }}>
                <h4 style={{ margin: 0, color: '#2c3e50', fontSize: isMobile ? '14px' : '16px'}}>         {isOpponentView ? 'Opponent Gear' : 'Team Gear'}
                </h4>
                <button
                    onClick={onClose}
                    style={{
                        backgroundColor: 'transparent',
                        border: 'none',
                        fontSize: isMobile ? '16px' : '18px',
                        cursor: 'pointer',
                        color: '#e74c3c',
                        padding: '5px'
                    }}
                >
                    ✕
                </button>
            </div>
            
            {selectedGear && (
                <div style={{
                    marginBottom: '15px',
                    padding: isMobile ? '8px' : '10px',
                    backgroundColor: '#fff3cd',
                    border: '1px solid #ffeaa7',
                    borderRadius: '4px',
                    fontSize: isMobile ? '12px' : '14px'
                }}>
                    <strong>Replacing: {selectedGear.name}</strong>
                </div>
            )}
            
            {availableGear && availableGear.length > 0 ? (
                <div style={{
                    maxHeight: isMobile ? '200px' : '300px',
                    overflowY: 'auto'
                }}>
                    {availableGear.map((gear, index) => {
                        // Disable equip if player has 3 or more gear pieces
                        const canEquip = equippedCount < 3 && (!gear.character_sheet || !gear.equipped);
                        return (
                            <div
                                key={gear.id || index}
                                style={{
                                    padding: isMobile ? '8px' : '12px',
                                    margin: isMobile ? '6px 0' : '8px 0',
                                    backgroundColor: '#ffffff',
                                    border: '1px solid #ddd',
                                    borderRadius: '6px',
                                    boxShadow: '0 1px 3px rgba(0,0,0,0.1)'
                                }}
                            >
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    flexWrap: isMobile ? 'wrap' : 'nowrap',
                                    gap: isMobile ? '8px' : '10px'
                                }}>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{
                                            fontWeight: 'bold',
                                            fontSize: isMobile ? '12px' : '14px',
                                            color: '#2c3e50',
                                            wordWrap: 'break-word'
                                        }}>
                                            {gear.name || `Gear ${index + 1}`}
                                        </div>
                                        {gear.description && (
                                            <div style={{
                                                fontSize: isMobile ? '10px' : '12px',
                                                color: '#636e72',
                                                marginTop: '2px',
                                                fontStyle: 'italic',
                                                wordBreak: 'break-word'
                                            }}>
                                                {gear.description}
                                            </div>
                                        )}
                                        <div style={{
                                            fontSize: isMobile ? '10px' : '12px',
                                            color: '#7f8c8d',
                                            marginTop: '2px'
                                        }}>
                                            Slot: {gear.slot || 'ANY'} | {gear.character_sheet ? (() => {
                                                let player = teamPlayers.find(p => p.character_sheet_id === gear.character_sheet) ||
                                                            teamPlayers.find(p => p.id === gear.character_sheet) ||
                                                            teamPlayers.find(p => p.character_sheet === gear.character_sheet);
                                                return `Equipped by: ${player?.name || 'Unknown Player'}`;
                                            })() : 'Available'}
                                        </div>
                                    </div>
                                    {!isOpponentView && (
                                        <div style={{
                                            flexShrink: 0,
                                            width: isMobile ? '100%' : 'auto',
                                            marginTop: isMobile ? '8px' : '0'
                                        }}>
                                            {gear.character_sheet && gear.equipped ? (
                                                <button
                                                    onClick={() => onGearUnequip && onGearUnequip(gear.id)}
                                                    style={{
                                                        padding: isMobile ? '6px 12px' : '4px 8px',
                                                        backgroundColor: '#e74c3c',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '4px',
                                                        fontSize: isMobile ? '11px' : '12px',
                                                        fontWeight: 'bold',
                                                        cursor: 'pointer',
                                                        width: isMobile ? '100%' : 'auto'
                                                    }}
                                                >
                                                    Unequip
                                                </button>
                                            ) : (
                                                <button
                                                    onClick={() => canEquip && onGearSelect && onGearSelect(gear)}
                                                    disabled={!canEquip}
                                                    style={{
                                                        padding: isMobile ? '6px 12px' : '4px 8px',
                                                        backgroundColor: canEquip ? '#27ae60' : '#b2bec3',
                                                        color: 'white',
                                                        border: 'none',
                                                        borderRadius: '4px',
                                                        fontSize: isMobile ? '11px' : '12px',
                                                        fontWeight: 'bold',
                                                        cursor: canEquip ? 'pointer' : 'not-allowed',
                                                        width: isMobile ? '100%' : 'auto',
                                                        opacity: canEquip ? 1 : 0.6
                                                    }}
                                                >
                                                    {equippedCount >= 3 ? 'Max 3 Equipped' : 'Equip to Player'}
                                                </button>
                                            )}
                                        </div>
                                    )}
                                    {isOpponentView && (
                                        <div style={{
                                            padding: isMobile ? '6px 12px' : '4px 8px',
                                            fontSize: isMobile ? '10px' : '12px',
                                            color: '#7f8c8d',
                                            fontStyle: 'italic'
                                        }}>
                                            View Only
                                        </div>
                                    )}
                                </div>
                            </div>
                        );
                    })}
                </div>
            ) : (
                <div style={{
                    textAlign: 'center',
                    color: '#7f8c8d',
                    fontStyle: 'italic',
                    padding: isMobile ? '30px 0' : '50px 0'
                }}>
                    <div style={{
                        fontSize: isMobile ? '32px' : '48px',
                        marginBottom: '10px'
                    }}>📦</div>
                    <div style={{ fontSize: isMobile ? '12px' : '14px' }}>
                        No gear available.
                    </div>
                </div>
            )}
        </div>
    );
}

export default GearSelectionPanel;